"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPreparedGenericRssFeed = getPreparedGenericRssFeed;
exports.slicePreparedGenericRssFeed = slicePreparedGenericRssFeed;
const feedMemoryCache_1 = require("./feedMemoryCache");
const parseGenericRssXml_1 = require("./parseGenericRssXml");
const rssRouteLimits_1 = require("./rssRouteLimits");
let genericFeedCache = null;
function getGenericFeedCache() {
    if (!genericFeedCache) {
        genericFeedCache = (0, feedMemoryCache_1.createTtlCache)({
            ttlMs: (0, rssRouteLimits_1.rssMemoryCacheTtlMs)(),
            maxKeys: (0, rssRouteLimits_1.rssMemoryCacheMaxKeys)(),
            staleMs: (0, rssRouteLimits_1.rssMemoryCacheStaleMs)(),
        });
    }
    return genericFeedCache;
}
async function getPreparedGenericRssFeed(feedUrl, loadXml) {
    const cache = getGenericFeedCache();
    return cache.getOrCreate(feedUrl, async () => {
        const xml = await loadXml();
        const { title, description, items: raw } = (0, parseGenericRssXml_1.parseGenericRssXml)(xml);
        const descMax = (0, rssRouteLimits_1.rssUrlDescriptionMaxChars)();
        const trimmed = (0, rssRouteLimits_1.trimGenericRssItemDescriptions)(raw, descMax);
        const cap = (0, rssRouteLimits_1.genericRssMaxCachedItems)();
        const items = trimmed.length > cap ? trimmed.slice(0, cap) : trimmed;
        return { title, description, items };
    });
}
async function slicePreparedGenericRssFeed(feedUrl, offset, limit, loadXml) {
    const p = await getPreparedGenericRssFeed(feedUrl, loadXml);
    const slice = p.items.slice(offset, offset + limit);
    return {
        title: p.title,
        description: p.description,
        item: slice,
        totalItems: p.items.length,
        offset,
        limit,
        hasMore: offset + slice.length < p.items.length,
    };
}
